import React from 'react'

export const IconReuse = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill='currentColor' {...props}>
        <path d="M5.516 14.22c-2.262-2.44-2.222-6.244.12-8.62 .96-.97 2.16-1.55 3.41-1.74L8.97 1.78c-1.76.21-3.46.996-4.8 2.351C1.02 7.3.98 12.42 4.04 15.66l-1.75 1.75 5.51.3 -.02-5.834 -2.31 2.32Zm6.647-11.96l.01 5.834 2.3-2.33c2.26 2.43 2.22 6.246-.13 8.61 -.97.96-2.17 1.54-3.42 1.73l.06 2.07c1.75-.22 3.452-1 4.798-2.35 3.14-3.18 3.186-8.3.12-11.54l1.74-1.754 -5.51-.3Z"></path>
    </svg>
  )
}
